import {CampaignSignal} from 'common/src/modules/excelToCampaign/excelToCampaign.types';
import _groupBy from 'lodash/groupBy';
import _keyBy from 'lodash/keyBy';
import _pickBy from 'lodash/pickBy';
import {ColumnToSignalMapping} from '../../../excelToCampaignAgent.types';
import {MappingValidationError} from '../validateMappingsTool.types';

function validateDuplicateMappings({
  allSignals,
  mappings,
}: {
  allSignals: CampaignSignal[];
  mappings: ColumnToSignalMapping[];
}): MappingValidationError[] {
  const signalsByKey = _keyBy(allSignals, 'signalKey');
  const mappingBySignalKey = _groupBy(mappings, 'signalKey');

  const duplicateMappings = _pickBy(mappingBySignalKey, (mappings) => mappings.length > 1);

  const issues = Object.keys(duplicateMappings)
    .filter(Boolean)
    .map((signalKey) => {
      const signal = signalsByKey[signalKey];

      return {
        messageToUser: `There are multiple potential headers for the campaign element "${signal.name}". Please choose which one of them to use.`,
        instructionsForAgent: '',
      };
    });

  return issues;
}

export default validateDuplicateMappings;
